import styles from './index.module.scss';
import axios from 'axios/axios';
import { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import { useSelector } from 'react-redux';
export default function BeyondAI() {
  const [isJoined, setIsJoined] = useState(false);
  const [showJoinDialog, setShowJoinDialog] = useState(false);
  const [watchTrailer, setWatchTrailer] = useState(false);
  const { userDetails } = useSelector(state => state.auth);

  useEffect(() => {
    getJoinWaitlist();
  }, []);

  const getJoinWaitlist = async () => {
    try {
      let { response } = await axios.get('/auth/beyond/waitlist?type=get');
      setIsJoined(response?.userData === null ? false : response?.data);
    } catch (error) {
      console.error(error);
    }
  };

  const joinWaitlist = async () => {
    try {
      await axios.get('/auth/beyond/waitlist?type=post');
      setShowJoinDialog(true);
      setIsJoined(true);
    } catch (error) {
      console.error(error);
    }
  };

  const watchTrailerButton = () => {
    return (
      <>
        {watchTrailer ? (
          <button className={styles.button} onClick={() => setWatchTrailer(false)}>
            Stop Trailer
          </button>
        ) : (
          <button className={styles.button} onClick={() => setWatchTrailer(true)}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="25"
              height="25"
              viewBox="0 0 25 25"
              fill="none"
            >
              <path
                d="M8.5 6.9873L18.5 12.9873L8.5 18.9873V6.9873Z"
                fill="white"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
            </svg>
            Watch Trailer
          </button>
        )}
      </>
    );
  };
  return (
    <>
      {/* <Dialog showHeader={false} visible={watchTrailer} style={{ width: '50vw' }} onHide={() => { if (!showJoinDialog) return; setShowJoinDialog(false); }} className="trailerDialog">
                <video style={{ width: "100%", height: "400px" }} controls>
                    <source src="https://cobi-service-files.s3.us-east-1.amazonaws.com/BeyondAI_Trailer.mp4" type="video/mp4" />
                    Your browser does not support the video tag.
                </video>

                <button onClick={() => setWatchTrailer(false)}>
                    Close
                </button>

            </Dialog> */}

      <Dialog
        showHeader={false}
        visible={showJoinDialog}
        breakpoints={{ '960px': '75vw', '640px': '100vw' }}
        style={{ width: '37vw' }}
        onHide={() => {
          if (!showJoinDialog) return;
          setShowJoinDialog(false);
        }}
        className="joinWaitListDialog"
      >
        <div className="box">
          <div className="p-3">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="26"
              height="27"
              viewBox="0 0 26 27"
              fill="none"
            >
              <path
                d="M12.9814 0.487305C5.84161 0.487305 0 6.32892 0 13.4687C0 20.6084 5.84161 26.45 12.9814 26.45C20.1211 26.45 25.9627 20.6084 25.9627 13.4687C25.9627 6.32892 20.1211 0.487305 12.9814 0.487305ZM10.3851 19.9594L3.89441 13.4687L5.72478 11.6383L10.3851 16.2856L20.2379 6.43277L22.0683 8.27612L10.3851 19.9594Z"
                fill="#31C859"
              />
            </svg>
            <h1>
              You're all set! Your waitlist spot is <span>confirmed</span>
            </h1>
            <p>We’ll notify you when it’s your turn to access the Beyond AI Store</p>
          </div>
          <div className="email">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M11.6667 3.15405H2.33341C1.69175 3.15405 1.17258 3.64155 1.17258 4.23739L1.16675 10.7374C1.16675 11.3332 1.69175 11.8207 2.33341 11.8207H11.6667C12.3084 11.8207 12.8334 11.3332 12.8334 10.7374V4.23739C12.8334 3.64155 12.3084 3.15405 11.6667 3.15405ZM11.6667 5.32072L7.00008 8.02905L2.33341 5.32072V4.23739L7.00008 6.94572L11.6667 4.23739V5.32072Z"
                fill="#A4A4A4"
              />
            </svg>
            {userDetails?.email}
          </div>
        </div>
        <button onClick={() => setShowJoinDialog(false)}>Continue</button>
      </Dialog>
      <div className={styles.rightPanel}>
        {watchTrailer ? (
          <video style={{ width: '100%', height: '400px' }} controls autoPlay>
            <source
              src="https://cobi-service-files.s3.us-east-1.amazonaws.com/BeyondAI_Trailer.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
        ) : (
          <div className={styles.box}>
            <img src="/assets/icons/beyond_star.png" alt="icons" className={styles.logo} />

            <h1>Join the closed alpha for Beyond Intelligence</h1>
            <p>Get early access to the Beyond Intelligence, by signing up for the waitlist.</p>
            {!isJoined ? (
              <div className={styles.tag}>
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="13"
                  height="12"
                  viewBox="0 0 13 12"
                  fill="none"
                >
                  <circle cx="6.5" cy="5.92847" r="5.61035" fill="#FFC300" />
                </svg>
                Join the Waitlist
              </div>
            ) : (
              <div className={styles.tag}>
                {isJoined?.isWhiteListed ? (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <circle cx="6.5" cy="5.92847" r="5.61035" fill="#C4FF1F" />
                    </svg>
                    Access Now Available
                  </>
                ) : (
                  <>
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="13"
                      height="12"
                      viewBox="0 0 13 12"
                      fill="none"
                    >
                      <circle cx="6.5" cy="5.92847" r="5.61035" fill="#FF6B00" />
                    </svg>
                    On the Waitlist
                  </>
                )}
              </div>
            )}
          </div>
        )}

        {!isJoined ? (
          <div className="flex align-items-center gap-2 w-full">
            <button
              className={`${styles.joinButton} ${styles.button}`}
              onClick={() => joinWaitlist()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="21"
                viewBox="0 0 20 21"
                fill="none"
              >
                <path
                  d="M7.5 2.4873C7.63261 2.4873 7.75979 2.53998 7.85355 2.63375C7.94732 2.72752 8 2.8547 8 2.9873V4.9873C8 5.11991 7.94732 5.24709 7.85355 5.34086C7.75979 5.43463 7.63261 5.4873 7.5 5.4873C7.36739 5.4873 7.24021 5.43463 7.14645 5.34086C7.05268 5.24709 7 5.11991 7 4.9873V2.9873C7 2.8547 7.05268 2.72752 7.14645 2.63375C7.24021 2.53998 7.36739 2.4873 7.5 2.4873ZM3.61 4.0973C3.65645 4.05074 3.71162 4.0138 3.77237 3.98859C3.83311 3.96339 3.89823 3.95041 3.964 3.95041C4.02977 3.95041 4.09489 3.96339 4.15563 3.98859C4.21638 4.0138 4.27155 4.05074 4.318 4.0973L5.732 5.5123C5.77975 5.55843 5.81785 5.6136 5.84405 5.6746C5.87026 5.7356 5.88405 5.80121 5.88463 5.8676C5.8852 5.93399 5.87255 5.99983 5.84741 6.06128C5.82227 6.12273 5.78514 6.17856 5.7382 6.2255C5.69125 6.27245 5.63543 6.30957 5.57398 6.33472C5.51253 6.35986 5.44669 6.37251 5.3803 6.37193C5.31391 6.37135 5.2483 6.35756 5.1873 6.33136C5.1263 6.30515 5.07112 6.26706 5.025 6.2193L3.611 4.8053C3.51726 4.71154 3.46461 4.58439 3.46461 4.4518C3.46461 4.31922 3.51726 4.19207 3.611 4.0983M11.391 4.0983C11.4376 4.14475 11.4745 4.19993 11.4997 4.26067C11.5249 4.32142 11.5379 4.38654 11.5379 4.4523C11.5379 4.51807 11.5249 4.58319 11.4997 4.64394C11.4745 4.70468 11.4376 4.75986 11.391 4.8063L9.974 6.2193C9.92788 6.26706 9.8727 6.30515 9.8117 6.33136C9.7507 6.35756 9.68509 6.37135 9.6187 6.37193C9.55231 6.37251 9.48647 6.35986 9.42502 6.33472C9.36357 6.30957 9.30775 6.27245 9.2608 6.2255C9.21386 6.17856 9.17673 6.12273 9.15159 6.06128C9.12645 5.99983 9.1138 5.93399 9.11438 5.8676C9.11495 5.80121 9.12874 5.7356 9.15495 5.6746C9.18115 5.6136 9.21924 5.55843 9.267 5.5123L10.681 4.0983C10.7748 4.00457 10.9019 3.95191 11.0345 3.95191C11.1671 3.95191 11.2942 4.00457 11.388 4.0983M2 7.9873C2 7.8547 2.05268 7.72752 2.14645 7.63375C2.24021 7.53998 2.36739 7.4873 2.5 7.4873H4.5C4.63261 7.4873 4.75979 7.53998 4.85355 7.63375C4.94732 7.72752 5 7.8547 5 7.9873C5 8.11991 4.94732 8.24709 4.85355 8.34086C4.75979 8.43463 4.63261 8.4873 4.5 8.4873H2.5C2.36739 8.4873 2.24021 8.43463 2.14645 8.34086C2.05268 8.24709 2 8.11991 2 7.9873ZM7.5 8.5193V17.7793C7.49982 17.8783 7.52905 17.9752 7.58398 18.0576C7.63891 18.1399 7.71706 18.2042 7.80854 18.2421C7.90001 18.28 8.00068 18.2899 8.09779 18.2705C8.1949 18.2512 8.28407 18.2034 8.354 18.1333L10.914 15.5733C11.289 15.1982 11.7976 14.9874 12.328 14.9873H15.56C15.6638 14.9872 15.765 14.9549 15.8495 14.8947C15.9341 14.8345 15.9978 14.7495 16.0319 14.6514C16.066 14.5534 16.0687 14.4472 16.0397 14.3475C16.0107 14.2479 15.9514 14.1597 15.87 14.0953L8.31 8.1263C8.23626 8.06803 8.14758 8.03172 8.05415 8.02155C7.96071 8.01137 7.8663 8.02773 7.78174 8.06876C7.69718 8.10979 7.6259 8.17382 7.57606 8.25351C7.52623 8.3332 7.49987 8.42532 7.5 8.5193Z"
                  fill="white"
                />
              </svg>
              Join Waitlist
            </button>
            {watchTrailerButton()}
          </div>
        ) : (
          <>
            {isJoined?.isWhiteListed ? (
              <>
                <div className="flex align-items-center gap-2 w-full">
                  <button disabled className={styles.button}>
                    Visit the Store
                  </button>
                </div>
              </>
            ) : (
              <>
                <div className="flex align-items-center gap-2 w-full">{watchTrailerButton()}</div>
              </>
            )}
          </>
        )}
      </div>
    </>
  );
}
